import classNames from 'classnames';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import IconButton from "../../../../../common/buttons/icon-button/IconButton";
import styles from './DeleteEngineCompartmentApiKeyModal.module.scss';
import IDeleteEngineCompartmentApiKeyModalProps from "./IDeleteEngineCompartmentApiKeyModalProps";
import IDeleteEngineCompartmentApiKeyModalState from "./IDeleteEngineCompartmentApiKeyModalState";

export default class DeleteEngineCompartmentApiKeyModal extends Component<IDeleteEngineCompartmentApiKeyModalProps, IDeleteEngineCompartmentApiKeyModalState> {

  private static removeDialogIndex = 100;

  constructor(props: IDeleteEngineCompartmentApiKeyModalProps) {
    super(props);

    this.state = {
      dialogId: 'delete_engineCompartment_apiKey_dialog_' + (DeleteEngineCompartmentApiKeyModal.removeDialogIndex++)
    };

    this.onConfirmClicked = this.onConfirmClicked.bind(this);
  }

  render() {
    return (
      <ReactModal
        appElement={document.getElementById('root') as HTMLElement}
        isOpen={this.props.showDialog}
        id={this.state.dialogId}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        className={classNames([styles.dialog, "shadow p-4"])}
      >
        <h1>Delete api key</h1>

        <p>Are you sure you want to delete Engine Compartment connection key <b className="text-break">{this.props.accessKeyToDelete}</b>?</p>

        <div className="d-flex justify-content-end">
          <IconButton onClick={this.onConfirmClicked} variant="outline-primary" title="Delete" styles={{marginRight: '1em'}}/>
          <IconButton onClick={this.props.onCancel} variant="outline-primary" title="Cancel"/>
        </div>
      </ReactModal>
    );
  }

  onConfirmClicked() {
    if (this.props.onConfirm !== undefined && this.props.onConfirm !== null) {
      this.props.onConfirm(this.props.projectIdToDelete ?? 0);
    }
  }
}
